import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import { type Chapter, formatTime } from '@/lib/cue-parser'

type Props = {
  isOpen: boolean
  onClose: () => void
  chapters: Chapter[]
  currentChapterIndex: number
  onChapterSelect: (chapter: Chapter) => void
}

export const ChapterSheet = ({ isOpen, onClose, chapters, currentChapterIndex, onChapterSelect }: Props) => {
  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <SheetContent side="bottom" className="max-h-[70vh]">
        <SheetHeader>
          <SheetTitle>チャプター</SheetTitle>
        </SheetHeader>
        <div className="overflow-y-auto mt-4 -mx-2">
          {chapters.map((chapter, idx) => (
            <button
              key={chapter.index}
              type="button"
              onClick={() => onChapterSelect(chapter)}
              className={`w-full flex items-center gap-3 px-4 py-3 text-left transition-colors rounded-md ${
                idx === currentChapterIndex ? 'bg-primary/10 text-primary' : 'hover:bg-muted'
              }`}
            >
              <span className="text-xs text-muted-foreground w-8 shrink-0 text-right">{chapter.index}</span>
              <span className="flex-1 text-sm truncate">{chapter.title}</span>
              <span className="text-xs text-muted-foreground shrink-0">{formatTime(chapter.startTime)}</span>
            </button>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  )
}
